export enum ApiMetric {
  PLAY = 'play',
  PAUSE = 'pause',
  SEEK = 'seek',
  GO_LIVE = 'go_live',
}
